export enum IndicatorThemeType {
    Pending,
    Stale,
}
